import * as React from "react"
import "./sticky-header.scss"
import { Link } from "@reach/router";

const StickyHeader: React.FC<{ previousPage?: string }> = ({ previousPage }) => {
  return (
    <div className="tedx-bath-logo-bar">
      {previousPage != undefined ? <Link to={`/${previousPage}`} className="back-arrow">arrow-left2</Link> : ''}
      <img src={require("../assets/images/tedx-bath-logo-only-white.svg")} alt="TEDx Bath logo" className="tedx-bath-logo" />
    </div>
  )
}

export default StickyHeader;